import { com, kotlin } from '@eidu/form'
import formsBaseUrl from './baseUrl'
import bearerTokenHeader from '../authorization/bearerTokenHeader'
import Page = com.eidu.sharedlib.form.definition.Page
import KtList = kotlin.collections.KtList
import decodeFormContentFromJson = com.eidu.sharedlib.form.decodeFormContentFromJson
import { requireAuthContext } from '../authorization/GlobalAuthContext'

type GetFormContentTextParameters = {
  formId: String
  formContentId: string
}

const getFormContent = async ({ formId, formContentId }: GetFormContentTextParameters): Promise<KtList<Page>> => {
  const authContext = await requireAuthContext()
  return fetch(
    `${formsBaseUrl}/organizations/${authContext.organizationId}/forms/${formId}/contents/${formContentId}`,
    {
      headers: bearerTokenHeader(authContext.accessToken),
    }
  ).then(async (it) => {
    const response = await it.text()
    if (it.status === 200) return decodeFormContentFromJson(response)
    else throw Error(`Unexpected response code ${it.status} from getFormContentText endpoint`)
  })
}

export default getFormContent
